/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

// @ts-ignore
import {GetLocalText} from "./../../themes/kent/utilities/functions";
// @ts-ignore
import {ModelYear, GeneralAssetUrl} from "./../../themes/kent/utilities/constants";

interface IState {}

interface IProps {
  product?: any;
}

/**
 *
 * Sizes component
 * @extends {React.PureComponentReact.Component<IProps,IState>}
 */

class WakeboardFlexNumber extends React.Component<IProps,IState> {
  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  public render(): JSX.Element {
    let image = GeneralAssetUrl+"flex-meter-1.png";
		if(this.props.product.attributes.wakeboardFlexNumber == 2){
			image = GeneralAssetUrl+"flex-meter-2.png";
		}
		if(this.props.product.attributes.wakeboardFlexNumber == 3){
			image = GeneralAssetUrl+"flex-meter-3.png";
		}
		if(this.props.product.attributes.wakeboardFlexNumber == 4){
			image = GeneralAssetUrl+"flex-meter-4.png";
		}
		if(this.props.product.attributes.wakeboardFlexNumber == 5){
			image = GeneralAssetUrl+"flex-meter-5.png";
		}
		if(!this.props.product.attributes.wakeboardFlexNumber) return <span />;
		return (
			<div className="max-width-container centered-text wakeboard-flex-number small-padding">
				<img style={{width:200, marginBottom:20, margin:'auto'}} src={image} />
			</div>
		)
  }
}

export default WakeboardFlexNumber;
